import { render, staticRenderFns } from "./PublisherScenariosTab.vue?vue&type=template&id=5522b23c"
import script from "./PublisherScenariosTab.vue?vue&type=script&lang=js"
export * from "./PublisherScenariosTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports